import { useEffect } from 'react';

// Native <img> elements are used throughout this app.  Keeping the behavior
// here avoids changing page markup or the APIs that provide image URLs.
export default function ImageLoadingFallback() {
    useEffect(() => {
        const root = document.getElementById('root');
        if (!root) return undefined;

        const markImage = (image) => {
            if (!image.currentSrc && !image.src) return;

            // Cached images are already complete, so never leave a loader on
            // them for a render frame.
            image.dataset.imageState = image.complete && image.naturalWidth > 0
                ? 'loaded'
                : 'pending';
        };

        const markLoaded = (event) => {
            if (event.target instanceof HTMLImageElement) {
                event.target.dataset.imageState = 'loaded';
            }
        };

        const markFailed = (event) => {
            if (event.target instanceof HTMLImageElement) {
                // Keep the visual only for a real failure, where the original
                // image area would otherwise be empty.
                event.target.dataset.imageState = 'error';
            }
        };

        const scan = (node) => {
            if (node instanceof HTMLImageElement) markImage(node);
            if (node instanceof Element) node.querySelectorAll('img').forEach(markImage);
        };

        root.querySelectorAll('img').forEach(markImage);
        root.addEventListener('load', markLoaded, true);
        root.addEventListener('error', markFailed, true);

        const observer = new MutationObserver((changes) => {
            changes.forEach((change) => {
                if (change.type === 'attributes') markImage(change.target);
                else change.addedNodes.forEach(scan);
            });
        });
        observer.observe(root, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['src', 'srcset'],
        });

        return () => {
            observer.disconnect();
            root.removeEventListener('load', markLoaded, true);
            root.removeEventListener('error', markFailed, true);
        };
    }, []);

    return null;
}
